import { useSelector } from 'react-redux';
import { ConditionalDisplay } from '@rsos/base-components';
import useIsTT911Enabled from '@rsos/hooks/useIsTT911Enabled';
import checkAgent511Access from '@rsos/utils/checkAgent511Access';
import { SettingsManagementState } from '../../reducers';
import styles from '../settings.module.css';
import { Agent511AudioSettings } from './Agent511AudioSettings';
import { FollowupReplySettings } from './FollowupReplySettings';
import { InitialTextMessageAudioSettings } from './InitialTextMessageAudioSettings';

export const TextMessagingSettings = () => {
  const hasAgent511 = useHasAgent511();
  const isTT911Enabled = useIsTT911Enabled();

  return (
    <div className={styles.section}>
      <h2 className={styles.title}>911 Text Messaging</h2>
      <div className={styles.description}>
        Manage notification settings and alert sounds for all 911 text sessions.
      </div>
      <div className={styles.cardBlock}>
        <ConditionalDisplay
          dataName="agent-511-settings"
          conditions={[
            {
              showIf: hasAgent511,
              reason:
                'Agent511 Capability and Permission need to be on to show these settings',
            },
          ]}
        >
          <Agent511AudioSettings />
        </ConditionalDisplay>

        <ConditionalDisplay
          dataName="initial-inbound-text-settings"
          conditions={[
            {
              showIf: isTT911Enabled,
              reason:
                'TT911 capability must be enabled to show the initial inbound text settings',
            },
          ]}
        >
          <InitialTextMessageAudioSettings />
        </ConditionalDisplay>
        <FollowupReplySettings />
      </div>
    </div>
  );
};

// This is still a travesty but I have to stop somewhere
function useHasAgent511() {
  const psaps = useSelector((state: SettingsManagementState) => state.psaps);
  const sinatra = useSelector(
    (state: SettingsManagementState) => state.sinatra,
  );
  return checkAgent511Access(psaps, sinatra) as boolean;
}
